/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TenantHealthSkippedEmail } from './TenantHealthSkippedEmail';
import {
    TenantHealthSkippedEmailFromJSON,
    TenantHealthSkippedEmailFromJSONTyped,
    TenantHealthSkippedEmailToJSON,
} from './TenantHealthSkippedEmail';

/**
 * 
 * @export
 * @interface TenantHealthSkippedEmails
 */
export interface TenantHealthSkippedEmails {
    /**
     * 
     * @type {Array<TenantHealthSkippedEmail>}
     * @memberof TenantHealthSkippedEmails
     */
    emails?: Array<TenantHealthSkippedEmail>;
}

/**
 * Check if a given object implements the TenantHealthSkippedEmails interface.
 */
export function instanceOfTenantHealthSkippedEmails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthSkippedEmailsFromJSON(json: any): TenantHealthSkippedEmails {
    return TenantHealthSkippedEmailsFromJSONTyped(json, false);
}

export function TenantHealthSkippedEmailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthSkippedEmails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emails': !exists(json, 'emails') ? undefined : ((json['emails'] as Array<any>).map(TenantHealthSkippedEmailFromJSON)),
    };
}

export function TenantHealthSkippedEmailsToJSON(value?: TenantHealthSkippedEmails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emails': value.emails === undefined ? undefined : ((value.emails as Array<any>).map(TenantHealthSkippedEmailToJSON)),
    };
}

